// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5t-2";
export var blackBorderOnHover = "_5t-7";
export var cell = "_5t-6";
export var cellContainer = "_5t-3";
export var checked = "_5t-8";
export var disabled = "_5t-5";
export var featuredIconCellContainer = "_5t-9";
export var featuredIconTextContainer = "_5t-b";
export var featuredIconWrapper = "_5t-a";
export var noBorder = "_5t-c";
export var orangeSelectedRow = "_ed-3";
export var overflowableText = "_5t-0";
export var overflowableTextContainer = "_5t-1";
export var row = "_5v-0";
export var rowCheckboxCell = "_5t-4";
export var selectableTable = "_ed-2";